// Shared playback engine for rendering animation frames
export function renderFrame(el, kf, fontSize, projectBackground) {
  el.innerHTML = '';
  if (fontSize) el.style.fontSize = fontSize + 'px';
  const bg = kf.backgroundColor || projectBackground;
  if (bg) el.style.backgroundColor = bg;

  for (let r = 0; r < kf.rows; r++) {
    for (let c = 0; c < kf.cols; c++) {
      const cell = kf.grid[r][c];
      const span = document.createElement('span');
      span.style.color = cell.color || kf.defaultColor || '#ca4b15';
      span.textContent = cell.char || ' ';
      el.appendChild(span);
    }
    if (r < kf.rows - 1) el.appendChild(document.createTextNode('\n'));
  }
}

export function createPlayer(keyframes, sequence, displayEl, fontSize, projectBackground) {
  let step = 0;
  let timer = null;
  let playing = false;
  let speed = 1;
  let loop = true;
  let onStepChange = null;

  function playStep() {
    if (!playing) return;
    const steps = sequence.steps;
    if (!steps || steps.length === 0) { stop(); return; }

    if (step >= steps.length) {
      if (loop) { step = 0; } else { stop(); return; }
    }

    const s = steps[step];
    const kf = keyframes[s.keyframeId];
    if (kf) renderFrame(displayEl, kf, fontSize, projectBackground);
    if (onStepChange) onStepChange(step);

    const delay = s.duration / speed;
    timer = setTimeout(() => { step++; playStep(); }, delay);
  }

  function play() {
    if (playing) return;
    playing = true;
    step = 0;
    playStep();
  }

  function stop() {
    playing = false;
    clearTimeout(timer);
  }

  function pause() {
    playing = false;
    clearTimeout(timer);
  }

  function resume() {
    if (playing) return;
    playing = true;
    playStep();
  }

  function toggle() {
    if (playing) pause(); else resume();
  }

  function setSpeed(s) { speed = s; }
  function setLoop(l) { loop = l; }
  function isPlaying() { return playing; }
  function getStep() { return step; }

  function goToStep(idx) {
    stop();
    step = idx;
    const steps = sequence.steps;
    if (steps && steps[step]) {
      const kf = keyframes[steps[step].keyframeId];
      if (kf) renderFrame(displayEl, kf, fontSize, projectBackground);
    }
    if (onStepChange) onStepChange(step);
  }

  function destroy() {
    stop();
    onStepChange = null;
  }

  return { play, stop, pause, resume, toggle, setSpeed, setLoop, isPlaying, getStep, goToStep, destroy, onStepChange: (fn) => { onStepChange = fn; } };
}
